const MENU_BRANCHES = [
  { match: /^\/queue(?:\/|$)/, parents: [["Pelayanan Pasien", "/appointment/list/0"], ["Antrean Klinik", "/queue"]] },
  { match: /^\/home-care(?:\/|$)/, parents: [["Pelayanan Pasien", "/home-care"], ["Home Care", "/home-care"]] },
  { match: /^\/appointment(?:\/|$)/, parents: [["Pelayanan Pasien", "/appointment/list/0"], ["Pendaftaran & Janji", "/appointment/list/0"]] },
  { match: /^\/(patient|prescriptions|medical-checkup)(?:\/|$)/, parents: [["Pelayanan Pasien", "/patient/list"], ["Pasien", "/patient/list"]] },
  { match: /^\/(doctor|schedule)(?:\/|$)/, parents: [["Pelayanan Pasien", "/doctor/list"], ["Dokter", "/doctor/list"]] },
  { match: /^\/bpjs(?:\/|$)/, parents: [["Pelayanan Pasien", "/bpjs"], ["BPJS", "/bpjs"]] },
  { match: /^\/(inpatient)(?:\/|$)/, parents: [["Pelayanan Pasien", "/inpatient"], ["Rawat Inap", "/inpatient"]] },
  { match: /^\/quality(?:\/|$)/, parents: [["Pelayanan Pasien", "/quality"], ["Mutu & Keselamatan", "/quality"]] },
  { match: /^\/(medical-action|lab-procedure|lab-report|bed|blood-bank|donor)(s|-|\/|$)/, parents: [["Layanan Klinis", "/medical-actions/list"]] },
  { match: /^\/(medicine|stock-opnames|stock-opname-report|purchase-orders-pharmacy)(?:\/|$)/, parents: [["Farmasi", "/medicine/control-center"], ["Obat & Alat Kesehatan", "/medicine/list"]] },
  { match: /^\/pharmacy(?:\/|$)/, parents: [["Farmasi", "/pharmacy/control-center"], ["Pelayanan Apotek", "/pharmacy/sales"]] },
  { match: /^\/(payment|billing)(s|\/|$)/, parents: [["Kasir & Pendapatan", "/payment/list"], ["Pembayaran", "/payment/list"]] },
  { match: /^\/payment-categories(?:\/|$)/, parents: [["Kasir & Pendapatan", "/payment-categories/list"], ["Produk Layanan", "/payment-categories/list"]] },
  { match: /^\/(inventory|purchase-orders)(?:\/|$)/, parents: [["Inventori Umum", "/inventory/list"], ["Data Inventori", "/inventory/list"]] },
  { match: /^\/(crm|promo|coupon|efectivity-dashboard|marketing-effectiveness)(?:\/|$)/, parents: [["Customer Relationship (CRM)", "/crm"]] },
  { match: /^\/(finance|expense|payroll|human-resource|polyclinic)(s|\/|$)/, parents: [["SDM & Keuangan", "/finance" ] ] },
  { match: /^\/(report|journal-report|action-report)(s|\/|$)/, parents: [["Laporan & Analitik", "/report"]] },
  { match: /^\/(user-managements|announcements)(?:\/|$)/, parents: [["Administrasi", "/user-managements/user-access"]] },
  { match: /^\/website(?:\/|$)/, parents: [["Website & CMS", "/website/setting"]] },
  { match: /^\/(setting|configuration|profile|guide|help)(s|\/|$)/, parents: [["Lain-Lain", "/settings/quick-access"], ["Sistem & Bantuan", "/settings/quick-access"]] },
  { match: /^\/trust-center(?:\/|$)/, parents: [["Sistem & Bantuan", "/settings/quick-access"]] },
  { match: /^\/satu-sehat(?:\/|$)/, parents: [["Integrasi SATUSEHAT", "/satu-sehat/dashboard"]] },
  { match: /^\/subscribe(?:\/|$)/, parents: [["Akun & Langganan", "/subscribe/package"]] },
];

const TITLE_ROUTES = {
  "Antrean Klinik": "/queue",
  "Home Care": "/home-care",
  "Pendaftaran & Janji": "/appointment/list/0",
  Pasien: "/patient/list",
  Dokter: "/doctor/list",
  "Obat & Alat Kesehatan": "/medicine/list",
  "Pelayanan Apotek": "/pharmacy/sales",
  Pembayaran: "/payment/list",
  "Produk Layanan": "/payment-categories/list",
  "Laporan & Analitik": "/report",
};

function sameTitle(left, right) {
  return String(left || "").trim().toLocaleLowerCase("id-ID") ===
    String(right || "").trim().toLocaleLowerCase("id-ID");
}

export function resolveBreadcrumbs(path, breadcrumbs) {
  const source = Array.isArray(breadcrumbs) ? breadcrumbs.filter(item => item && item.title) : [];
  const current = source[source.length - 1];
  if (!current) return [];

  const branch = MENU_BRANCHES.find(item => item.match.test(path || ""));
  const parents = branch
    ? branch.parents.map(([title, route]) => ({ title, route }))
    : source.slice(0, -1).map(item => ({ ...item, route: item.route || TITLE_ROUTES[item.title] }));

  const result = parents.filter((item, index) => {
    if (sameTitle(item.title, current.title)) return false;
    return index === 0 || !sameTitle(item.title, parents[index - 1].title);
  });

  result.push({ ...current });
  return result;
}
